export function clampDragPreviewPosition({
  sourceX,
  sourceY,
  elementWidth,
  bounds
}) {
  const clampedX = Math.max(bounds.left, Math.min(bounds.right - elementWidth, sourceX));
  const clampedY = Math.max(bounds.top, sourceY);
  return {
    deltaX: clampedX - sourceX,
    deltaY: clampedY - sourceY
  };
}